import request from '../request'

export default {
    getCurrentUser() {
        return request.get('usuario/me')
    },

    getUsuarios() {
        return request.get('usuario')
    },

    addUsuario(newUser) {
        return request.post('usuario', newUser)
    },

    updateUsuario(userData) {
        return request.put(`usuario/${userData.userId}`, userData)
    },

    updateEstadoUsuario(userData) {
        return request.put(`usuario/${userData.userId}/estado`, { estado: userData.estado })
    },

    updatePasswordUsuario(userData) {
        return request.put(`usuario/${userData.userId}/password`, userData)
    }
}